import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';
import { aladb } from 'db'
import _ from 'lodash'
import { Chart } from 'react-google-charts';

import './CardLanguageUsage.css'

export default () => {
	const sqlData = aladb.db.exec(`
		SELECT getLanguage(language) AS lang, COUNT(*) AS cnt 
		FROM Log 
		GROUP BY getLanguage(language)
		ORDER BY COUNT(*) DESC
	`);

	const data = [
		['Language', 'Count'],
		..._.map(sqlData, v => [v.lang, v.cnt])
	];

	const options = {
		pieHole: 0.4,
		legend: {
			alignment: "center",
			position: 'right',
			textStyle: {fontSize: 20}
		},
		chartArea: {
			top: 10,
			bottom: 10,
			left: 10,     // set this eventually, to adjust the left margin
			right: 10
		},
		fontSize: 16
	};

	return (
		<Card>
			<CardTitle title="Welche Sprache wird angefordert?"/>
			<CardText>
				<Chart
					chartType="PieChart"
					data={data}
					options={options}
					graph_id="chart-language-usage"
				/>
			</CardText>
		</Card>
	);
};


// WEBPACK FOOTER //
// ./src/components/summary/cards/CardLanguageUsage.jsx